import React, { useState } from 'react';
import useSeo from '../hooks/useSeo';
import './Pages.css';

function Contact() {
  useSeo(
    'Contact Rev-Tech | Managed IT & Cybersecurity Services',
    'Contact Rev-Tech for managed IT, cybersecurity consulting, audit support, and technical project services.',
    {
      ogTitle: 'Contact Rev-Tech | Managed IT & Cybersecurity Services',
      ogDescription: 'Contact Rev-Tech for managed IT, cybersecurity consulting, audit support, and technical project services.',
      twitterTitle: 'Contact Rev-Tech | Managed IT & Cybersecurity Services',
      twitterDescription: 'Contact Rev-Tech for managed IT, cybersecurity consulting, audit support, and technical project services.',
      canonical: 'https://www.rev-technology.com/contact'
    }
  );

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    interest: '',
    numberOfComputers: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  return (
    <div className="page">
      <h1>Contact Us</h1>
      <p className="page-subtitle">We'd love to hear from you. Get in touch with us today!</p>
      
      <div className="contact-container">
        <div className="contact-form-wrapper">
          <form
            name="contact"
            method="POST"
            action="/thank-you"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
            className="contact-form"
          >
            <input type="hidden" name="form-name" value="contact" />
            <p className="hidden-field">
              <label>
                Don’t fill this out if you’re human: <input name="bot-field" />
              </label>
            </p>
            <div className="form-group">
              <label htmlFor="name">Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="interest">I am interested in</label>
              <select
                id="interest"
                name="interest"
                value={formData.interest}
                onChange={handleChange}
              >
                <option value="">Select an option</option>
                <option value="Core">Core Service Package</option>
                <option value="Advanced">Advanced Service Package</option>
                <option value="TotalCare">TotalCare Service Package</option>
                <option value="Consulting">Consulting Services</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="numberOfComputers">Number of computers</label>
              <input
                type="number"
                id="numberOfComputers"
                name="numberOfComputers"
                min="1"
                value={formData.numberOfComputers}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message *</label>
              <textarea
                id="message"
                name="message"
                rows="6"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <button type="submit" className="submit-btn">Send Message</button>
          </form>
        </div>

        <div className="contact-info">
          <h2>Contact Information</h2>
          <div className="info-item">
            <h3>Phone</h3>
            <p>(863) 209-4372</p>
          </div>
          <div className="info-item">
            <h3>Email</h3>
            <p>info@rev-technology.com</p>
          </div>
          <div className="info-item">
            <h3>Business Hours</h3>
            <p>Monday - Friday: 8:00 AM - 5:00 PM EST<br />Saturday & Sunday: Closed</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
